import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ViewSearchBox from 'components/ViewSearchBox';
import 'css/HomePage.scss';
import ViewHorizontalNavigation from 'components/ViewHorizontalNavigation';
import ViewEventList from 'containers/ViewEventList';
import ViewSpinner from 'components/ViewSpinner';
import * as PreEventsActions from 'actions/PreEventsActions';
import * as UiSportPreActions from 'actions/UiSportPreActions';
import { ModelService } from 'utils/ModelService';
import moment from 'moment';
import 'moment/locale/da';
import RestService from 'utils/RestService';
import ViewToggleListToolbar from 'components/ViewToggleListToolbar';
import { browserHistory } from 'react-router';
import { isTerminal, scrollToTop } from 'utils/UiHelper';
import { SPORTS } from 'constants/appConfig';
import { SkeletonWrapper } from '../components/SkeletonUI/styled';
import SearchFieldSkeleton from '../components/SkeletonUI/SearchFieldSkeleton/SearchFieldSkeleton';
import HorizontalNavigationSkeleton from '../components/SkeletonUI/HorizontalNavigationSkeleton/HorizontalNavigationSkeleton';
import ViewEventListSkeleton from '../components/SkeletonUI/ViewEventListSkeleton/ViewEventListSkeleton';

class SectionPreTab extends Component {
    rangesWereUpdated = false;

    constructor(props) {
        super(props);

        this.state = {
            ranges: null,
            openRange: {},
            isConfigLoading: true,
        };
    }

    getRanges() {
        RestService.GetConfig((gc) => {
            const ranges = [];
            const currentMoment = moment(gc.date + ' ' + gc.time);

            while (ranges.length < 12) {
                const tmpM = currentMoment.format('HH');
                const tmp = tmpM + ':00';

                currentMoment.add('1', 'hours');

                ranges.push({
                    title: tmp + ' - ' + currentMoment.format('HH') + ':00',
                    strKey: tmpM,
                });
            }

            this.setState(() => ({ ranges, isConfigLoading: false }));
        });
    }

    componentDidMount() {
        this.fetchPreEvents();
        this.getRanges();
        this._setEventsBySportAndTime();
        this._setRangeStatuses();
        window.addEventListener('focus', this.windowFocusHandler);
        scrollToTop();
    }

    componentWillUnmount() {
        window.removeEventListener('focus', this.windowFocusHandler);
    }

    windowFocusHandler = () => {
        this.getRanges();
    };

    fetchPreEvents = () => {
        this.props.preEventsActions.getTodayEvents();
    };

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.activeSportId === 0 &&
            nextProps.preEventsBySportAndTime &&
            Object.keys(nextProps.preEventsBySportAndTime).length > 0
        ) {
            const sport = Object.keys(nextProps.preEventsBySportAndTime)[0];

            if (sport) {
                this.props.uiSportPreActions.setActiveSportId(sport);
            } else {
                this.props.uiSportPreActions.setActiveSportId(
                    Object.keys(nextProps.preEventsBySportAndTime)[0]
                );
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.preEvents.data !== this.props.preEvents.data) {
            this._setEventsBySportAndTime();
        }
        if (!prevState.ranges && this.state.ranges) {
            this._setEventsBySportAndTime();
        }
        if (
            prevProps.preEventsBySportAndTime !==
            this.props.preEventsBySportAndTime
        ) {
            this._setRangeStatuses();
        }
        if (prevProps.activeSportId !== this.props.activeSportId) {
            this._setRangeStatuses();
        }
    }

    _setEventsBySportAndTime() {
        if (this.state.ranges && this.props.preEvents.fetched) {
            this.props.uiSportPreActions.setEventsBySportAndTime(
                this.props.preEvents.data,
                this.state.ranges
            );
        }
    }

    _setRangeStatuses() {
        if (
            this.props.activeSportId &&
            !this.state.openRange[this.props.activeSportId] &&
            this.props.preEventsBySportAndTime
        ) {
            const limitOfOpenedItems = 3;

            let openRange = {
                ...this.state.openRange,
            };

            let isNeedOpenFirstRange = false;
            let counter = 0;

            let activeSportId = this.props.activeSportId;

            if (!openRange[activeSportId]) {
                openRange[activeSportId] = {};
                isNeedOpenFirstRange = true;
            }

            for (let rangeKey in this.props.preEventsBySportAndTime[
                activeSportId
            ]) {
                if (!isNeedOpenFirstRange) {
                    openRange[activeSportId][rangeKey] = false;
                } else {
                    openRange[activeSportId][rangeKey] = true;

                    if (counter >= limitOfOpenedItems - 1) {
                        isNeedOpenFirstRange = false;
                    }
                }

                counter++;
            }

            this.setState({ openRange });

            this.rangesWereUpdated = true;
        }
    }

    horizontalNavClickHandler(item) {
        this.props.uiSportPreActions.setActiveSportId(item.id);
    }

    onToggleElement(status, id) {
        let openRange = {
            ...this.state.openRange,
        };

        openRange[this.props.activeSportId][id] = !openRange[
            this.props.activeSportId
        ][id];

        this.setState({ openRange: openRange });
    }

    onSearchTextHandler(searchText) {
        this.props.uiSportPreActions.search(searchText);
    }

    backBtnHandler() {
        browserHistory.push('/sport/');
    }

    checkValidTournaments(tournament) {
        return (
            tournament.homeTeam &&
            tournament.awayTeam &&
            tournament.marketList.length &&
            tournament.marketCount
        );
    }

    getFilteredSports() {
        return this.props.preEventsBySportAndTime &&
            this.props.sportTree.fetched
            ? this.props.sportTree.sportData.filter((item) => {
                  const rangesBySportId =
                      this.props.preEventsBySportAndTime[item.id] || {};
                  const hasValidTournaments = Object.values(
                      rangesBySportId
                  ).some((range) => range.some(this.checkValidTournaments));
                  /*BS-355*/
                  return (
                      rangesBySportId &&
                      ![
                          SPORTS.GOLF,
                          SPORTS.CYKLING,
                          SPORTS.MOTOR_SPORT,
                      ].includes(item.id) &&
                      hasValidTournaments
                  );
              })
            : [];
    }

    setDefaultActiveSportId() {
        const [first] = this.getFilteredSports();

        if (first) {
            this.props.uiSportPreActions.setActiveSportId(first.id);
        }
    }
    render() {
        const spinner = <ViewSpinner />;
        let activeSportId = this.props.activeSportId;
        const filteredSports = this.getFilteredSports();
        const isInitialLoading =
            this.props.preEvents.pending ||
            !this.props.sportTree.fetched ||
            this.state.isConfigLoading;

        const horizontalNav =
            filteredSports.length > 0 ? (
                <ViewHorizontalNavigation
                    showBackBtn={true}
                    backBtnHandler={() => {
                        browserHistory.push('/sport/');
                    }}
                    mode="pre"
                    items={filteredSports}
                    clickHandler={this.horizontalNavClickHandler.bind(this)}
                    selectedId={activeSportId !== '0' ? activeSportId : 'none'}
                />
            ) : null;

        let ranges = spinner;

        if (
            this.state.ranges &&
            activeSportId &&
            this.props.preEventsBySportAndTime &&
            this.state.openRange[activeSportId]
        ) {
            ranges = this.state.ranges.map((range) => {
                const preEvents = this.props.preEventsBySportAndTime[
                    activeSportId
                ]?.[range.strKey];
                const filteredPreEvents = preEvents
                    ? preEvents.filter(this.checkValidTournaments)
                    : [];

                if (filteredPreEvents.length > 0) {
                    let viewEventList = null;

                    if (!this.props.searchText) {
                        if (
                            this.state.openRange[activeSportId] &&
                            this.state.openRange[activeSportId][range.strKey]
                        ) {
                            viewEventList = (
                                <ViewEventList
                                    events={ModelService.getSportTree(
                                        this.props.sportTree.sportData,
                                        filteredPreEvents,
                                        'array',
                                        0,
                                        null,
                                        'sportId',
                                        [3]
                                    )}
                                />
                            );
                        }

                        return (
                            <div className="event-tab" key={range.strKey}>
                                <ViewToggleListToolbar
                                    title={range.title}
                                    toggleHandler={this.onToggleElement.bind(
                                        this
                                    )}
                                    tournamentId={range.strKey}
                                    opened={
                                        this.state.openRange &&
                                        this.state.openRange[activeSportId] &&
                                        this.state.openRange[activeSportId][
                                            range.strKey
                                        ] === true
                                            ? 'yes'
                                            : 'no'
                                    }
                                />
                                {viewEventList}
                            </div>
                        );
                    } else {
                        let filteredEvents = this.props.preEventsBySportAndTime[
                            activeSportId
                        ][range.strKey].filter((item) => {
                            return (
                                item?.homeTeam
                                    ?.toLowerCase()
                                    ?.indexOf(
                                        this.props.searchText.toLowerCase()
                                    ) > -1 ||
                                item?.awayTeam
                                    ?.toLowerCase()
                                    ?.indexOf(
                                        this.props.searchText.toLowerCase()
                                    ) > 0
                            );
                        });

                        if (
                            this.state.openRange[activeSportId] &&
                            this.state.openRange[activeSportId][range.strKey]
                        ) {
                            viewEventList = (
                                <ViewEventList
                                    events={ModelService.getSportTree(
                                        this.props.sportTree.sportData,
                                        filteredEvents,
                                        'array',
                                        0,
                                        null,
                                        'sportId'
                                    )}
                                />
                            );
                        }

                        if (filteredEvents.length > 0) {
                            return (
                                <div key={range.strKey}>
                                    <ViewToggleListToolbar
                                        title={range.title}
                                        toggleHandler={this.onToggleElement.bind(
                                            this
                                        )}
                                        tournamentId={range.strKey}
                                        opened={
                                            this.state.openRange &&
                                            this.state.openRange[
                                                activeSportId
                                            ] &&
                                            this.state.openRange[activeSportId][
                                                range.strKey
                                            ] === true
                                                ? 'yes'
                                                : 'no'
                                        }
                                    />{' '}
                                    {viewEventList}
                                </div>
                            );
                        } else {
                            return null;
                        }
                    }
                } else {
                    return null;
                }
            });
        }

        if (
            this.state.ranges &&
            !activeSportId &&
            this.props.preEventsBySportAndTime &&
            Object.keys(this.state.openRange).length > 0
        ) {
            if (ranges.length > 0) {
                if (ranges.filter((range) => range).length === 0) {
                    ranges = (
                        <div className="p10 message">
                            Ingen begivenheder fundet.
                        </div>
                    );
                }
            } else {
                ranges = (
                    <div className="p10 message">
                        Ingen begivenheder fundet.
                    </div>
                );
            }
        }

        return (
            <section>
                {isTerminal() ? (
                    <ViewSearchBox
                        onSearchTextHandler={this.onSearchTextHandler.bind(
                            this
                        )}
                        value={this.props.searchText}
                    />
                ) : !isInitialLoading ? (
                    <ViewSearchBox
                        showBackBtn="true"
                        onSearchTextHandler={this.onSearchTextHandler.bind(
                            this
                        )}
                        backBtnHandler={this.backBtnHandler.bind(this)}
                        value={this.props.searchText}
                    />
                ) : (
                    <SkeletonWrapper>
                        <SearchFieldSkeleton />
                    </SkeletonWrapper>
                )}

                {isInitialLoading ? (
                    <SkeletonWrapper>
                        <HorizontalNavigationSkeleton />
                    </SkeletonWrapper>
                ) : (
                    horizontalNav
                )}
                {isInitialLoading ? (
                    <SkeletonWrapper>
                        <ViewEventListSkeleton keyword={'pre'} />
                    </SkeletonWrapper>
                ) : (
                    <div className="tabs-container">{ranges}</div>
                )}
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
        preEvents: state.preEvents,
        sportTree: state.sportTree,
        activeSportId: state.uiSportPre.activeSportId,
        preEventsBySportAndTime: state.uiSportPre.preEventsBySportAndTime,
        searchText: state.uiSportPre.searchText,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        preEventsActions: bindActionCreators(PreEventsActions, dispatch),
        uiSportPreActions: bindActionCreators(UiSportPreActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SectionPreTab);
